export default{
    url:'https://play.missionerelax.it/api/',
    token: null,
    user_id: null,
    items: {},
    fprices:{},
    time: {},
}
